import { useState, useEffect } from "react";
import { GetAxios } from "../helpers/axiosHelpers";

/**
 * Hook to fetch navigation items from the backend
 * @param {string} location - Location filter (e.g., "navbar-main", "footer-company")
 * @returns {{ items: Array, loaded: boolean }}
 */
export const useNavigationItems = (location) => {
  const [items, setItems] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const endpoint = location
      ? `/navigation-items/public?location=${location}`
      : '/navigation-items/public';

    GetAxios(endpoint)
      .then((res) => {
        if (res?.success && Array.isArray(res.data)) {
          setItems(res.data);
        }
      })
      .catch(() => {
        // Fail silently, component will use fallback
      })
      .finally(() => setLoaded(true));
  }, [location]);

  return { items, loaded };
};
